import React from 'react';

const BackgroundSamples = () => {
  const samples = [
    {
      id: 1,
      name: 'Subtle Paper Grain',
      style: {
        background: '#fafaf9',
        backgroundImage: `
          radial-gradient(circle at 20% 50%, rgba(0,0,0,0.01) 0%, transparent 50%),
          radial-gradient(circle at 80% 80%, rgba(0,0,0,0.01) 0%, transparent 50%),
          radial-gradient(circle at 40% 20%, rgba(0,0,0,0.01) 0%, transparent 50%)
        `
      }
    },
    {
      id: 2,
      name: 'Fine Noise Texture',
      style: {
        background: '#fdfdfb',
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.03'/%3E%3C/svg%3E")`
      }
    },
    {
      id: 3,
      name: 'Woven Paper',
      style: {
        background: '#fcfcfb',
        backgroundImage: `
          repeating-linear-gradient(0deg, rgba(0,0,0,0.01) 0px, transparent 1px, transparent 2px, rgba(0,0,0,0.01) 3px),
          repeating-linear-gradient(90deg, rgba(0,0,0,0.01) 0px, transparent 1px, transparent 2px, rgba(0,0,0,0.01) 3px)
        `
      }
    },
    {
      id: 4,
      name: 'Organic Paper',
      style: {
        background: '#fefefe',
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter2'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.5' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter2)' opacity='0.02'/%3E%3C/svg%3E")`,
        backgroundSize: '100px 100px'
      }
    },
    {
      id: 5,
      name: 'Cream Paper',
      style: {
        background: '#fffef9',
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 300 300' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter3'%3E%3CfeTurbulence type='turbulence' baseFrequency='0.7' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter3)' opacity='0.025'/%3E%3C/svg%3E")`
      }
    },
    {
      id: 6,
      name: 'Recycled Paper',
      style: {
        background: '#f9f9f7',
        backgroundImage: `
          radial-gradient(circle at 10% 20%, rgba(0,0,0,0.008) 0%, transparent 40%),
          radial-gradient(circle at 90% 80%, rgba(0,0,0,0.008) 0%, transparent 40%),
          radial-gradient(circle at 50% 50%, rgba(0,0,0,0.008) 0%, transparent 40%),
          radial-gradient(circle at 30% 70%, rgba(0,0,0,0.008) 0%, transparent 40%)
        `
      }
    }
  ];

  return (
    <div className="min-h-screen p-8 bg-gray-100">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold text-center mb-4 text-gray-900">Paper Texture Background Samples</h1>
        <p className="text-center text-gray-600 mb-12">Choose your preferred textured paper background</p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {samples.map((sample) => (
            <div key={sample.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div 
                className="h-64 p-8 flex items-center justify-center"
                style={sample.style}
              >
                <div className="text-center">
                  <div className="text-6xl font-bold text-gray-800 mb-4">Aa</div>
                  <p className="text-gray-700">Sample Text</p>
                  <p className="text-sm text-gray-500">The quick brown fox</p>
                </div>
              </div>
              <div className="bg-gray-800 p-4">
                <h3 className="text-white font-bold text-lg">Option {sample.id}</h3>
                <p className="text-gray-300 text-sm">{sample.name}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 text-sm">All textures are optimized for performance and use the lightest possible colors</p>
        </div>
      </div>
    </div>
  );
};

export default BackgroundSamples;
